import { render, staticRenderFns } from "./FormItemSelectCod.vue?vue&type=template&id=1034a27f&"
import script from "./FormItemSelectCod.vue?vue&type=script&lang=js&"
export * from "./FormItemSelectCod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports